import maintainRequest from "@/maintain/utils/maintainRequest";

function payDeviceAnnualFee(params) {
  return maintainRequest.get(`/device/maintenanceMan/chargingPile/payDeviceAnnualFee`, {
    params,
  });
}

function refreshCache(ids) {
  return maintainRequest.post(
    `/device/common/device/refreshCacheByIds?ids=${ids}`
  );
}

export { payDeviceAnnualFee, refreshCache };

